export type Lang = "pt" | "en";

const PT = {
  name: "Chat FillSign",
  tagline: "Assistente do FillSign",
  open: "Chat",
  close: "Fechar",
  minimize: "Minimizar",
  newChat: "Nova conversa",
  placeholder: "Pergunte sobre seus documentos...",
  send: "Enviar",
  view: "Visualizar",
  download: "Baixar",
  openPage: "Abrir",
  previewTitle: "Visualização",
  greet: "Olá!",
  hello: "Olá! Este é o chat do FillSign. Posso procurar seus documentos, enviar o PDF assinado, mostrar a auditoria ou explicar como o FillSign funciona.",
  suggestions: [
    "Quais documentos estão pendentes?",
    "Quem ainda não assinou?",
    "Me manda o último contrato assinado",
    "Como envio um documento?",
  ],
  slow: "Só mais um instante...",
  thinking: "Consultando...",
  typingAlong: "Pode escrever.",
  sleepy: "Chat em espera. É só escrever quando precisar.",
  wake: "Pronto para ajudar.",
  offline: "Não consegui falar com o servidor agora. Tente de novo em instantes.",
  tooMany: "Muitas mensagens em pouco tempo. Tente de novo em um minuto.",
  sessionExpired: "Sua sessão expirou. Entre de novo para continuar.",
  fileError: "Não consegui abrir o arquivo agora.",
  attach: "Anexar print",
  imageOnly: "Só imagens (PNG, JPG) até 4 MB.",
  uploadError: "Não consegui enviar a imagem.",
  confirm: "Confirmar",
  dismiss: "Cancelar",
  chooseFile: "Escolher arquivo (PDF ou Word)",
  actionDone: "Feito",
  actionDismissed: "Cancelado",
  actionFailed: "Não deu certo",
  actionExpired: "Este pedido expirou. Peça de novo no chat.",
  poke: ["Olá!", "Em que posso ajudar?", "Pronto para ajudar."],
  handoff: "Avisei a equipe por e-mail. Alguém responde para você em breve.",
};

const EN: typeof PT = {
  name: "FillSign chat",
  tagline: "FillSign assistant",
  open: "Chat",
  close: "Close",
  minimize: "Minimize",
  newChat: "New conversation",
  placeholder: "Ask about your documents...",
  send: "Send",
  view: "View",
  download: "Download",
  openPage: "Open",
  previewTitle: "Preview",
  greet: "Hello!",
  hello: "Hello! This is the FillSign chat. I can find your documents, send the signed PDF, show the audit trail or explain how FillSign works.",
  suggestions: [
    "Which documents are pending?",
    "Who hasn't signed yet?",
    "Send me the latest signed contract",
    "How do I send a document?",
  ],
  slow: "Just a moment...",
  thinking: "Checking...",
  typingAlong: "Go ahead.",
  sleepy: "Chat on standby. Just type when you need it.",
  wake: "Ready to help.",
  offline: "I couldn't reach the server right now. Please try again in a moment.",
  tooMany: "Too many messages in a short time. Try again in a minute.",
  sessionExpired: "Your session expired. Sign in again to continue.",
  fileError: "I couldn't open the file right now.",
  attach: "Attach screenshot",
  imageOnly: "Images only (PNG, JPG) up to 4 MB.",
  uploadError: "I couldn't upload the image.",
  confirm: "Confirm",
  dismiss: "Cancel",
  chooseFile: "Choose file (PDF or Word)",
  actionDone: "Done",
  actionDismissed: "Cancelled",
  actionFailed: "That didn't work",
  actionExpired: "This request expired. Ask again in the chat.",
  poke: ["Hello!", "How can I help?", "Ready to help."],
  handoff: "I've emailed the team. Someone will get back to you soon.",
};

export function assistantTexts(lang: string): typeof PT {
  return lang === "en" ? EN : PT;
}
